import React from 'react';
import {
  BudgetRequest,
  BudgetRequestRecipientStatus,
  BudgetRequestRecipient,
} from '@models/budget.model';
import { useTranslation } from '@hooks/useTranslation';

interface DelegationInfoProps {
  task: any;
  currentBudgetRequest: BudgetRequest | null;
}

export const DelegationInfo: React.FC<DelegationInfoProps> = ({
  task,
  currentBudgetRequest,
}) => {
  const tTaskDetail = useTranslation('taskDetail');
  const acceptedRecipient = currentBudgetRequest?.recipients?.find(
    (recipient: BudgetRequestRecipient) =>
      recipient.status === BudgetRequestRecipientStatus.ACCEPTED,
  );

  return (
    <div className="bg-purple-50 border border-purple-200 rounded-lg">
      <div className="p-4 border-b border-purple-200">
        <h3 className="text-lg font-medium text-gray-900">
          {tTaskDetail.budget.delegationInfoTitle}
        </h3>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {tTaskDetail.budget.delegatedTo}
            </label>
            <p className="text-sm text-gray-900">
              {task?.delegateOrganization?.name || tTaskDetail.budget.currentOrganization}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {tTaskDetail.budget.originalAcceptedOrg}
            </label>
            <p className="text-sm text-gray-900">
              {acceptedRecipient?.recipientOrganization?.name || tTaskDetail.budget.notAvailable}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};